import { Component, OnInit, Input } from '@angular/core';
import { Catalogo } from '../../interfaces/general';
import { FormGroup } from '@angular/forms';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-direccion-empresa',
  templateUrl: './direccion-empresa.component.html',
  styleUrls: ['./direccion-empresa.component.css']
})
export class DireccionEmpresaComponent implements OnInit {

  	otraCalle = false;
	Asentamiento: any
	municipios: any
	idEstado;
	@Input() tipoAsentamientos: Array<Catalogo>
	@Input() tipoCarreteras: Array<Catalogo>
	@Input() tipoCaminos: Array<Catalogo>
	@Input() Empresa_Direccion: FormGroup;
	@Input() estados: Array<any> = []

  constructor(private serviciosGenerales: ServiciosGeneralesService,) {

   }

  	ngOnInit(): void {
		this.obtenerCP()
  	}

  	obtenerCP(): void {
		this.Empresa_Direccion.get('Direcciones_CodigoPostal').valueChanges.pipe(
			debounceTime(1500)
		).subscribe(codigoPostal => (codigoPostal.length === 5) ? this.obtenerDatosCodigoPostal(codigoPostal) : '')
	}

	listarMunicipios(idEstado:number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res

		})
	}

	obtenerDatosCodigoPostal(codigoPostal: number) {
		this.serviciosGenerales.obtenerDatosCodigoPostal(codigoPostal).subscribe((res) => {
			console.log(res);
		})
	}

}
